import { timePeriodsFactory } from './categories';

const getRaceType = val => val.match(/jumps|flat/)[0];

const timePeriodReducer = (timePeriod, action) => {
    const { raceType, seasonsAvailable } = timePeriod.createdBy;
    if (action.type === 'raceType') {
        const newRaceType = getRaceType(action.value);
        if (raceType !== newRaceType) {
            return timePeriodsFactory(
                newRaceType,
                seasonsAvailable
            );
        }
    }
    return timePeriod;
};

const categoriesReducer = ({ raceType, timePeriod }, action) => ({
    raceType,
    timePeriod: timePeriodReducer(timePeriod, action),
});

export default categoriesReducer;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/components/categoriesReducer.js